import logo from "../../assets/logo1.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useKyc } from "../../context/KycContext";

function GridIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  );
}
function UserIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}
function WalletIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M16 12h2" />
    </svg>
  );
}
function IpIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="2" width="20" height="8" rx="2" />
      <rect x="2" y="14" width="20" height="8" rx="2" />
      <line x1="6" y1="6" x2="6.01" y2="6" />
      <line x1="6" y1="18" x2="6.01" y2="18" />
    </svg>
  );
}
function BankIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 10h16v10H4z" />
      <path d="M2 10l10-5 10 5" />
      <path d="M8 10v10M12 10v10M16 10v10" />
    </svg>
  );
}
function ServiceIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2" />
      <line x1="12" y1="22" x2="12" y2="15.5" />
      <polyline points="22 8.5 12 15.5 2 8.5" />
      <polyline points="2 15.5 12 8.5 22 15.5" />
      <line x1="12" y1="2" x2="12" y2="8.5" />
    </svg>
  );
}
function MyServiceIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
    </svg>
  );
}
function FundRequestIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function ApiKeyIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  );
}
function ComplaintsIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
    </svg>
  );
}
function GSTIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14,2 14,8 20,8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  );
}
function ActivityIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  );
}
function ChevronDownIcon({ isOpen }) {
  return (
    <svg className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

const NAV_ITEMS = [
  { icon: <GridIcon />,       label: "Dashboard",                  path: "/dashboard" },
  { icon: <UserIcon />,       label: "Kyc",                        path: "/kyc" },
  { icon: <WalletIcon />,     label: "Wallet",                     path: "/wallet" },
  { icon: <IpIcon />,         label: "My Ip's",                    path: "/myips" },
  { icon: <ServiceIcon />,    label: "Services",                   path: "/services" },
  { icon: <MyServiceIcon />,  label: "Service Wise Ledger Report", path: "/my-service" },
  { icon: <ActivityIcon />,   label: "Activity",                   path: "/activity", hasSubmenu: true },
  { icon: <GSTIcon />,        label: "GST Invoice",                path: "/gst-invoices" },
  { icon: <ComplaintsIcon />, label: "Complaints",                 path: "/complaints" },
  { icon: <FundRequestIcon />,label: "Fund Request",               path: "/fund-request" },
  { icon: <ApiKeyIcon />,     label: "API Key",                    path: "/api-key" },
  { icon: <BankIcon />,       label: "Whitelisted Banks",          path: "/whitelisted-banks" },
];

const ACTIVITY_TABS = [
  { name: "Login Activity",     path: "/activity?tab=loginActivity" },
  { name: "Dashboard Activity", path: "/activity?tab=DashboardActivity" },
];

export default function Sidebar({ activeTab = "Kyc" }) {
  const navigate = useNavigate();
  const [expandedActivity, setExpandedActivity] = useState(false);
  const { isRestricted, isVerified } = useKyc();

  const visibleItems = isRestricted
    ? NAV_ITEMS.filter(({ label }) => label === "Kyc")
    : NAV_ITEMS.filter(({ label }) => isVerified ? label !== "Kyc" : true);

  return (
    <aside className="w-[260px] flex flex-col bg-gradient-to-b from-[#754F89] to-[#4B2364] h-screen fixed left-0 top-0 shadow-[4px_0px_24px_rgba(75,35,100,0.08)]">
      <div className="flex flex-col flex-1 overflow-hidden">
        <div className="px-5 pt-5 pb-6 shrink-0">
          <img src={logo} alt="logo" className="w-full max-w-[160px]" />
        </div>

        <div className="flex-1 overflow-y-auto scrollbar-hide px-2 pb-6">
          {visibleItems.map(({ icon, label, path, hasSubmenu }) => {
            const active = label === activeTab;

            if (hasSubmenu) {
              return (
                <div key={label} className="mb-1">
                  <div
                    onClick={() => setExpandedActivity(!expandedActivity)}
                    className={`flex items-center justify-between px-4 py-3 rounded-xl cursor-pointer transition-all ${active ? "bg-[#FFFFFF26] text-white font-semibold" : "text-white/70 hover:text-white hover:bg-[#FFFFFF1A]"}`}
                  >
                    <div className="flex items-center gap-3.5">
                      <div className="w-[22px] flex justify-center items-center shrink-0">{icon}</div>
                      <span className="text-[15px]">{label}</span>
                    </div>
                    <ChevronDownIcon isOpen={expandedActivity} />
                  </div>
                  {expandedActivity && (
                    <div className="ml-[48px] mt-1 space-y-1">
                      {ACTIVITY_TABS.map((tab) => (
                        <div
                          key={tab.name}
                          onClick={() => navigate(tab.path)}
                          className="flex items-center gap-2 px-3 py-2 rounded-lg text-[13.5px] text-white/70 hover:bg-[#FFFFFF1A] hover:text-white cursor-pointer transition"
                        >
                          {tab.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <div
                key={label}
                onClick={() => path !== "#" && navigate(path)}
                className={`flex items-center gap-3.5 px-4 py-3 mb-1 rounded-xl cursor-pointer transition-all ${active ? "bg-[#FFFFFF26] text-white font-semibold" : "text-white/70 hover:text-white hover:bg-[#FFFFFF1A]"}`}
              >
                <div className="w-[22px] flex justify-center items-center shrink-0">{icon}</div>
                <span className="text-[15px]">{label}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="px-4 pb-4">
        <div className="text-[9px] tracking-widest text-white/50 mb-1">SUPPORT AGENT</div>
        <div className="text-white font-semibold text-sm">Vikram Sharma</div>
        <div className="text-white/60 text-xs">+91 98745 43210</div>
      </div>
    </aside>
  );
}
